import { render, staticRenderFns } from "./TitleRow.vue?vue&type=template&id=ec27c6e0"
import script from "./TitleRow.vue?vue&type=script&lang=js"
export * from "./TitleRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports